// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import myAccountFilterSectionStyles from "@awc/App/SharedStyles/MyAccountPages/List/MyAccountFilterSectionStyles";
import { constants } from "@awc/XDL/constants";
import { mergeWithCss, xScreen } from "@awc/XDL/Utilities";
import { dateRangeStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldDateRange";
import { css } from "styled-components";

dateRangeStyles.datePickersWrapper = {
    css: css`
        display: flex;
        align-items: flex-start;
        gap: 12px;
        &,
        & > div {
            flex: 1;
            ${xScreen("lte", constants.myAccountListPageFilter.breakpoints.xSmall)} {
                flex-direction: column;
                width: 100%;
            }
        }
    `,
};

dateRangeStyles.searchFieldWrapper = {
    wrapper: {
        css: css`
            width: 100%;
            flex: 0 1 calc((100% / 2) - 16px);
            min-width: 324px;
            display: flex;
            ${xScreen("lte", "sm")} {
                flex: 0 1 100%;
            }
        `,
    },
};

dateRangeStyles.fromDate = {
    ...mergeWithCss(myAccountFilterSectionStyles.fromDate, {
        cssOverrides: {
            formField: css`
                display: flex;
            `,
            formInputWrapper: css`
                &&& {
                    .react-datetime-picker {
                        min-height: 42px;
                    }
                }
            `,
        },
    }),
};

dateRangeStyles.toDate = {
    ...mergeWithCss(myAccountFilterSectionStyles.toDate, {
        cssOverrides: {
            formField: css`
                display: flex;
            `,

            datePicker: css`
                .react-calendar {
                    right: 0;
                    left: unset;
                }
            `,
            formInputWrapper: css`
                &&& {
                    .react-datetime-picker {
                        min-height: 42px;
                    }
                }
            `,
        },
    }),
};
